import React from 'react';

interface DomainNotApprovedProps {
  message: string;
  onRequestAccess?: () => void;
}

/**
 * Component shown when user's email domain is not approved
 */
const DomainNotApproved: React.FC<DomainNotApprovedProps> = ({ message, onRequestAccess }) => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      padding: '20px',
      backgroundColor: '#f5f5f5',
      textAlign: 'center'
    }}>
      <div style={{
        maxWidth: '500px',
        backgroundColor: 'white',
        padding: '40px',
        borderRadius: '8px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
      }}>
        <div style={{ fontSize: '64px', marginBottom: '20px' }}>🚫</div>
        
        <h1 style={{ 
          fontSize: '24px', 
          marginBottom: '16px',
          color: '#d32f2f'
        }}>
          Access Denied
        </h1>
        
        <p style={{ 
          fontSize: '16px', 
          color: '#666',
          marginBottom: '24px',
          lineHeight: '1.5'
        }}>
          {message}
        </p>
        
        <div style={{
          backgroundColor: '#fff3cd',
          border: '1px solid #ffc107',
          borderRadius: '4px',
          padding: '12px',
          marginBottom: '24px',
          fontSize: '14px',
          color: '#856404'
        }}>
          <strong>Why am I seeing this?</strong>
          <br />
          CCStudio is a controlled platform. Only approved organizations can access the system.
        </div>
        
        {onRequestAccess && (
          <button
            onClick={onRequestAccess}
            style={{
              backgroundColor: '#1976d2',
              color: 'white',
              border: 'none',
              padding: '12px 24px',
              borderRadius: '4px',
              fontSize: '16px',
              cursor: 'pointer',
              marginBottom: '12px'
            }}
          >
            Request Access
          </button>
        )}
        
        <div style={{ marginTop: '20px', fontSize: '14px', color: '#999' }}>
          <p>
            If you believe this is an error, please contact your system administrator.
          </p>
          <p style={{ marginTop: '8px' }}>
            Email: <a href="mailto:admin@creativescombined.com" style={{ color: '#1976d2' }}>
              admin@creativescombined.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default DomainNotApproved;
